import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const PROVIDERS = [
  { v: "gmail", label: "Gmail" },
  { v: "outlook", label: "Outlook / Office 365 (password)" },
  { v: "imap", label: "IMAP generico" },
];

export const AccountForm = ({ form, setForm, editingId, busy, onSubmit, onCancel }) => (
  <form onSubmit={onSubmit} className="border border-[#E5E4E0] bg-white p-6 grid grid-cols-1 md:grid-cols-2 gap-4 fade-up" data-testid="account-form">
    <div className="md:col-span-2 flex items-center justify-between gap-3 pb-3 border-b border-[#E5E4E0] -mt-2">
      <h3 className="font-display text-xl font-light">
        {editingId ? "Modifica account email" : "Nuovo account email"}
      </h3>
      {editingId && (
        <span className="text-[10px] font-mono uppercase tracking-[0.15em] px-2 py-1 bg-[#FBF6E9] text-[#8B6B00]">
          In modifica
        </span>
      )}
    </div>
    <div className="md:col-span-2">
      <Label className="label-mono">Etichetta</Label>
      <Input
        required
        data-testid="account-label-input"
        value={form.label}
        onChange={(e) => setForm({ ...form, label: e.target.value })}
        placeholder="Segreteria principale"
        className="mt-1 border-[#E5E4E0] bg-transparent focus:border-[#2C4C3B] focus:ring-0"
      />
    </div>
    <div>
      <Label className="label-mono">Provider</Label>
      <Select value={form.provider} onValueChange={(v) => setForm({ ...form, provider: v })}>
        <SelectTrigger data-testid="account-provider-select" className="mt-1 border-[#E5E4E0]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {PROVIDERS.map((p) => (
            <SelectItem key={p.v} value={p.v}>{p.label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
    <div>
      <Label className="label-mono">Indirizzo email</Label>
      <Input
        required
        type="email"
        data-testid="account-email-input"
        value={form.email_address}
        onChange={(e) => setForm({ ...form, email_address: e.target.value })}
        placeholder="info@agenzia.it"
        className="mt-1 border-[#E5E4E0] bg-transparent focus:border-[#2C4C3B] focus:ring-0"
      />
    </div>
    <div className="md:col-span-2">
      <Label className="label-mono">
        {editingId
          ? "Password app (lascia vuoto per mantenere quella esistente)"
          : "Password app (16 caratteri per Gmail/Outlook)"}
      </Label>
      <Input
        required={!editingId}
        type="password"
        data-testid="account-password-input"
        value={form.password}
        onChange={(e) => setForm({ ...form, password: e.target.value })}
        placeholder={editingId ? "Lascia vuoto per non modificarla" : "xxxx xxxx xxxx xxxx"}
        className="mt-1 border-[#E5E4E0] bg-transparent focus:border-[#2C4C3B] focus:ring-0 font-mono"
      />
      <p className="text-xs text-[#C85A32] mt-2">
        ⚠ Non è la password del tuo account! Devi generarne una dedicata. Vedi il box arancione sopra per le istruzioni.
      </p>
    </div>

    {form.provider === "imap" && (
      <>
        <div>
          <Label className="label-mono">IMAP host</Label>
          <Input
            required
            value={form.imap_host}
            onChange={(e) => setForm({ ...form, imap_host: e.target.value })}
            className="mt-1 border-[#E5E4E0] bg-transparent focus:border-[#2C4C3B] focus:ring-0"
          />
        </div>
        <div>
          <Label className="label-mono">IMAP port</Label>
          <Input
            type="number"
            value={form.imap_port}
            onChange={(e) => setForm({ ...form, imap_port: e.target.value })}
            placeholder="993"
            className="mt-1 border-[#E5E4E0] bg-transparent focus:border-[#2C4C3B] focus:ring-0"
          />
        </div>
        <div>
          <Label className="label-mono">SMTP host</Label>
          <Input
            required
            value={form.smtp_host}
            onChange={(e) => setForm({ ...form, smtp_host: e.target.value })}
            className="mt-1 border-[#E5E4E0] bg-transparent focus:border-[#2C4C3B] focus:ring-0"
          />
        </div>
        <div>
          <Label className="label-mono">SMTP port</Label>
          <Input
            type="number"
            value={form.smtp_port}
            onChange={(e) => setForm({ ...form, smtp_port: e.target.value })}
            placeholder="465"
            className="mt-1 border-[#E5E4E0] bg-transparent focus:border-[#2C4C3B] focus:ring-0"
          />
        </div>
      </>
    )}

    <div className="md:col-span-2 pt-3 border-t border-[#E5E4E0]">
      <div className="label-mono text-[#2C4C3B] mb-2">Reply-To (indirizzo dove ricevere le risposte)</div>
      <p className="text-xs text-[#8C8B8A] mb-3">
        Se compilato, quando un cliente clicca &quot;Rispondi&quot; sulla mail della Segretaria, la risposta partirà verso QUESTO indirizzo. Utile se la Segretaria manda via Gmail ma vuoi che i clienti rispondano al tuo indirizzo Outlook storico (che rigira a Gmail).
        Il MITTENTE visibile resta quello dell&apos;account Gmail — questo è un compromesso tecnico dovuto ai vincoli di autenticazione Microsoft (OAuth2 obbligatorio su outlook.it/com).
      </p>
      <Input
        data-testid="account-sendas-input"
        value={form.send_as}
        onChange={(e) => setForm({ ...form, send_as: e.target.value })}
        placeholder="puntarmanuel@outlook.it"
        className="mt-1 border-[#E5E4E0] bg-transparent focus:border-[#2C4C3B] focus:ring-0 font-mono text-xs"
      />
    </div>

    <div className="md:col-span-2 pt-3 border-t border-[#E5E4E0]">
      <div className="label-mono text-[#2C4C3B] mb-2">Riferimenti web dell&apos;agenzia (opzionali)</div>
      <p className="text-xs text-[#8C8B8A] mb-3">
        Verranno usati dalla Segretaria per arricchire le risposte. Per ora sono solo informativi; quando attiveremo lo scraping con proxy residenziale, l&apos;app aggiornerà il catalogo immobili in automatico.
      </p>
    </div>
    <div>
      <Label className="label-mono">URL agenzia su immobiliare.it</Label>
      <Input
        data-testid="account-immobiliare-input"
        value={form.immobiliare_url}
        onChange={(e) => setForm({ ...form, immobiliare_url: e.target.value })}
        placeholder="https://www.immobiliare.it/agenzie-immobiliari/118918/..."
        className="mt-1 border-[#E5E4E0] bg-transparent focus:border-[#2C4C3B] focus:ring-0 font-mono text-xs"
      />
    </div>
    <div>
      <Label className="label-mono">Sito web personale dell&apos;agenzia</Label>
      <Input
        data-testid="account-website-input"
        value={form.website_url}
        onChange={(e) => setForm({ ...form, website_url: e.target.value })}
        placeholder="https://www.abhomevenezia.com"
        className="mt-1 border-[#E5E4E0] bg-transparent focus:border-[#2C4C3B] focus:ring-0 font-mono text-xs"
      />
    </div>

    <div className="md:col-span-2 flex gap-2 mt-2">
      <Button
        type="submit"
        disabled={busy}
        data-testid="account-save-button"
        className="bg-[#2C4C3B] hover:bg-[#1E3629] text-white font-mono uppercase text-xs tracking-[0.2em]"
      >
        {busy ? "Salvataggio…" : editingId ? "Aggiorna account" : "Salva account"}
      </Button>
      {editingId && (
        <Button
          type="button"
          onClick={onCancel}
          data-testid="account-cancel-edit-button"
          variant="outline"
          className="border-[#E5E4E0] text-[#5C5B5A] hover:bg-[#F0EFEA] font-mono uppercase text-xs tracking-[0.2em]"
        >
          Annulla
        </Button>
      )}
    </div>
  </form>
);
